/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-multi-comp */
/* eslint-disable max-lines */

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { compose } from 'recompose';
import { find, get } from 'lodash';
import pluralize from 'pluralize';
import { Link } from 'react-router-dom';
import { Row, Col, Alert } from 'react-bootstrap';
import classNames from 'classnames';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import { Steps, Card, Button, Initial, Loader, Select, Modal } from 'sa-ui';

import { promisify } from '../../app/actions';

import { getEvaluationInformation, getGroups } from '../simulatedActions';
import {
  checkCoordinatorPermissionEvaluation,
  downloadPdf,
  generateEvaluationAnswerSheetsFiles,
  generateEvaluationAnswerSheetsFilesStatus,
  getEvaluationOnlineInProgress,
  logDownloadEssayGuidelines,
} from './simulatedEditionActions';
import { checkCoordinatorPermission } from '../../login/loginActions';

import SimulatedCorrectionTermsOfUseModal from '../correction/SimulatedCorrectionTermsOfUseModal';
import ComposingCorrectionTermsOfUseModal from '../composing-correction/ComposingCorrectionTermsOfUseModal';

import messages from './SimulatedEditionMessages';

import LoaderAnswerSheet from './LoaderAnswerSheet';

import * as helpers from '../simulatedHelpers';

import './SimulatedEditionContainer.scss';

import first_grade from './composingPDFs/1_ANO_ENSINO_MEDIO.pdf';
import second_grade from './composingPDFs/2_ANO_ENSINO_MEDIO.pdf';
import third_grade from './composingPDFs/3_ANO_ENSINO_MEDIO.pdf';
import sixth_year from './composingPDFs/6_ANO_ENSINO_FUNDAMENTAL.pdf';
import seventh_year from './composingPDFs/7_ANO_ENSINO_FUNDAMENTAL.pdf';
import eighth_year from './composingPDFs/8_ANO_ENSINO_FUNDAMENTAL.pdf';
import ninth_year from './composingPDFs/9_ANO_ENSINO_FUNDAMENTAL.pdf';

class SimulatedEditionContainer extends React.PureComponent {
  state = {
    evaluation: null,
    idCSchool: undefined,
    schoolType: undefined,
    idESCourse: undefined,
    schoolSelectedCourses: [],
    checkbox: {
      simulatedPdf: true,
      answersPdf: true,
      answersCardPdf: true,
      compositionSheets: true,
    },
    selectSchoolModal: false,
    showUploadModal: false,
    showUploadComposingModal: false,
    checkboxAllGroups: true,
    checkboxGroups: {},
    socketMessage: '',
    loadingMessage: '',
    composingCheckbox: {
      first_grade: false,
      second_grade: false,
      third_grade: false,
      sixth_year: false,
      seventh_year: false,
      eighth_year: false,
      ninth_year: false,
    },
    loading: false,
  };

  async componentDidMount() {
    await this.handleGetEvaluationInformation();
    await this.props.getEvaluationOnlineInProgress({
      idEvaluation: this.props.idEvaluation,
    });
    await this.props.checkCoordinatorPermission();
    await this.props.checkCoordinatorPermissionEvaluation({
      idEvaluation: this.props.idEvaluation,
    });
    await this.props.getGroups({ idEvaluation: this.props.idEvaluation });

    if (this.props.groups) {
      const idCSchool = JSON.parse(localStorage.getItem('idCSchool'));
      const idESCourse = JSON.parse(localStorage.getItem('idESCourse'));
      const filteredGroups = helpers.filterGroupsByEvaluationSchoolLevel(
        this.props.groups,
        idCSchool,
        this.props.evaluationLevel,
      );

      if (filteredGroups.length > 0) {
        this.setState({
          checkboxGroups: {},
          checkboxAllGroups: true,
        });

        filteredGroups.forEach((group) => {
          this.setState((prevState) => ({
            checkboxGroups: {
              ...prevState.checkboxGroups,
              [group.idESCourse]: true,
            },
          }));
        });
      }

      this.setState({
        idCSchool,
        idESCourse,
        schoolSelectedCourses: filteredGroups,
      });
    }
  }

  handleGetEvaluationInformation = () => {
    const { match } = this.props;
    this.props.getEvaluationInformation({
      idEvaluation: match.params.idEvaluation,
    });
  };

  handleChangeCheckboxAllGroups = () => {
    const { checkboxGroups } = this.state;

    if (Object.keys(checkboxGroups).length > 0) {
      Object.entries(checkboxGroups).forEach(([key]) => {
        this.setState((prevState) => ({
          checkboxGroups: {
            ...prevState.checkboxGroups,
            [key]: !prevState.checkboxAllGroups,
          },
        }));
      });
    }

    this.setState((prevState) => ({ checkboxAllGroups: !prevState.checkboxAllGroups }));
  };

  handleChangeCheckboxGroups = (idESCourse) => {
    this.setState(
      (prevState) => ({
        checkboxGroups: {
          ...prevState.checkboxGroups,
          [idESCourse]: !prevState.checkboxGroups[idESCourse],
        },
      }),
      () => {
        const { checkboxGroups } = this.state;

        if (Object.keys(checkboxGroups).length > 0) {
          let allChecked = true;
          Object.values(checkboxGroups).forEach((val) => {
            if (allChecked === true && val === false) {
              allChecked = false;
              this.setState({ checkboxAllGroups: false });
            }
          });
          if (allChecked) {
            this.setState({ checkboxAllGroups: true });
          }
        }
      },
    );
  };

  handleChangeSchool = (event) => {
    const idCSchool = event.target.value;

    const option = this.props.schoolOptions.find((s) => s.value === idCSchool);
    const schoolType = option ? option.schoolType : undefined;

    const filteredGroups = helpers.filterGroupsByEvaluationSchoolLevel(
      this.props.groups,
      idCSchool,
      this.props.evaluationLevel,
    );

    if (filteredGroups.length > 0) {
      this.setState({
        checkboxGroups: {},
        checkboxAllGroups: true,
      });

      filteredGroups.forEach((group) => {
        this.setState((prevState) => ({
          checkboxGroups: {
            ...prevState.checkboxGroups,
            [group.idESCourse]: true,
          },
        }));
      });
    }

    this.setState({
      idCSchool,
      schoolType,
      idESCourse: undefined,
      schoolSelectedCourses: filteredGroups,
    });
  };

  handleChangeSchoolFilter = (event) => {
    const idCSchool = event.target.value;

    const option = this.props.schoolOptions.find((s) => s.value === idCSchool);
    const schoolType = option ? option.schoolType : undefined;

    const filteredGroups = helpers.filterGroupsByEvaluationSchoolLevel(
      this.props.groups,
      idCSchool,
      this.props.evaluationLevel,
    );

    if (filteredGroups.length > 0) {
      this.setState({
        checkboxGroups: {},
        checkboxAllGroups: true,
      });

      filteredGroups.forEach((group) => {
        this.setState((prevState) => ({
          checkboxGroups: {
            ...prevState.checkboxGroups,
            [group.idESCourse]: true,
          },
        }));
      });
    }

    this.setState({
      idCSchool,
      schoolType,
      idESCourse: undefined,
      schoolSelectedCourses: filteredGroups,
    });

    if (idCSchool !== '') {
      localStorage.setItem('idCSchool', JSON.stringify(idCSchool));
    } else {
      localStorage.removeItem('idCSchool');
    }

    if (schoolType !== '') {
      localStorage.setItem('schoolType', JSON.stringify(schoolType));
    } else {
      localStorage.removeItem('schoolType');
    }

    localStorage.removeItem('idESCourse');
  };

  handleChangeIdESCourseFilter = (event) => {
    const idESCourse = event.target.value;
    this.setState({
      idESCourse,
    });
    if (idESCourse !== '') {
      localStorage.setItem('idESCourse', JSON.stringify(idESCourse));
    } else {
      localStorage.removeItem('idESCourse');
    }
  };

  showModalDownloadPdf = async () => {
    this.setState({ selectSchoolModal: true });
  };

  handleDownloadPdf = async (idsESCourse) => {
    const { simulatedPdf, answersPdf, answersCardPdf, compositionSheets } = this.state.checkbox;
    if (simulatedPdf || answersPdf || answersCardPdf || compositionSheets) {
      if (this.state.idCSchool) {
        try {
          await this.props.downloadPdf({
            idEvaluation: this.props.idEvaluation,
            idCSchool: this.state.idCSchool,
            schoolType: this.state.schoolType,
            idsESCourse,
            downloadEvaluationPDF: simulatedPdf,
            downloadFeedbackPDF: answersPdf,
            downloadAnswerSheetsPDF: answersCardPdf,
            downloadCompositionSheets: compositionSheets,
            filename: this.props.intl.formatMessage(messages.pdfFileName, {
              idCSchool: this.state.idCSchool,
              idEvaluation: this.props.idEvaluation,
            }),
          });
        } catch (error) {
          console.error('Erro ao baixar o PDF:', error);
        } finally {
          this.setState({ loadingMessage: '' });
        }
      }
    }
  };

  handleGenerateEvaluationAnswerSheetsFiles = async (idsESCourse) => {
    const { answersCardPdf } = this.state.checkbox;

    this.setState({
      loadingMessage: this.props.intl.formatMessage(messages.loadingMessage),
    });

    if (answersCardPdf) {
      if (this.props.idEvaluation && this.state.idCSchool && idsESCourse) {
        try {
          const response = await this.props.generateEvaluationAnswerSheetsFiles({
            idEvaluation: this.props.idEvaluation,
            idCSchool: this.state.idCSchool,
            idsESCourse,
            // random: randomNumber
          });
          const requestId = response.data.id;
          const t = setInterval(async () => {
            const response = await this.props.generateEvaluationAnswerSheetsFilesStatus({
              id: requestId,
            });
            const status = response.data.content;
            if (status === 2) {
              clearInterval(t);
              this.setState({
                loadingMessage: 'Cartões gerados. Criando arquivo para download...',
              });
              await this.handleDownloadPdf(idsESCourse);
              setTimeout(() => {
                this.setState({
                  loadingMessage: '',
                });
              }, 2000);
            }
          }, 10000);
        } finally {
        }
      }
    }
  };

  isDiagrammingCompleted = () => {
    const simulatedDates = get(this.props.simulated, 'evaluation.dates') || [];
    return !!simulatedDates.find((d) => d.component === 'diagramming' && d.complete === true);
  };

  handleUploadModal = () => {
    this.setState({
      showUploadModal: true,
    });
  };

  dismissHandleUploadModal = () => {
    this.setState({
      showUploadModal: false,
    });
    document.body.classList.remove('modal-open');
  };

  handleUploadComposingModal = () => {
    this.setState({
      showUploadComposingModal: true,
    });
  };

  dismissHandleUploadComposingModal = () => {
    this.setState({
      showUploadComposingModal: false,
    });
    document.body.classList.remove('modal-open');
  };

  handleClickUpload = () => {
    document.body.classList.remove('modal-open');
    this.props.history.push(`/simulated/${this.props.idEvaluation}/correction`);
  };

  handleClickUploadComposing = () => {
    document.body.classList.remove('modal-open');
    this.props.history.push(`/simulated/${this.props.idEvaluation}/composing-correction`);
  };

  handleLoaderAnswerSheet = async () => {
    const { checkboxGroups } = this.state;

    const idsESCourse = [];

    if (Object.keys(checkboxGroups).length > 0) {
      Object.entries(checkboxGroups).forEach(([key, value]) => {
        if (value) {
          idsESCourse.push(key);
        }
      });
    }

    if (idsESCourse.length > 0) {
      // setLoadingApi(true);
      try {
        if (!this.state.checkbox.answersCardPdf && this.state.checkbox.compositionSheets) {
          await this.handleDownloadPdf(idsESCourse);
        } else if (this.state.checkbox.answersCardPdf) {
          await this.handleGenerateEvaluationAnswerSheetsFiles(idsESCourse);
        } else {
          await this.handleDownloadPdf(idsESCourse);
        }
      } finally {
        // setLoadingApi(false);
      }
    }
  };

  handleDownloadComposingDoc = async () => {
    this.setState({ loading: true });

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const { composingCheckbox } = this.state;
    const pdfs = [];
    if (composingCheckbox.first_grade) pdfs.push(first_grade);
    if (composingCheckbox.second_grade) pdfs.push(second_grade);
    if (composingCheckbox.third_grade) pdfs.push(third_grade);
    if (composingCheckbox.sixth_year) pdfs.push(sixth_year);
    if (composingCheckbox.seventh_year) pdfs.push(seventh_year);
    if (composingCheckbox.eighth_year) pdfs.push(eighth_year);
    if (composingCheckbox.ninth_year) pdfs.push(ninth_year);

    const zip = new JSZip();
    for (const pdf of pdfs) {
      await fetch(pdf)
        .then((response) => response.blob())
        .then((blob) => {
          const filename = pdf.split('/').pop().split('?')[0];
          zip.file(filename, blob);
        });
      await delay(1000);
    }

    zip.generateAsync({ type: 'blob' }).then(async (content) => {
      const filename = 'orientações-de-correção.zip';
      saveAs(content, filename);
      
      // Log do download
      try {
        await this.props.logDownloadEssayGuidelines({
          idEvaluation: this.props.idEvaluation,
          filename: filename,
          evaluationName: (this.props.simulated && this.props.simulated.evaluation && this.props.simulated.evaluation.name) || '',
          idCSchool: this.state.idCSchool || '',
        });
      } catch (error) {
        console.error('Erro ao registrar log do download:', error);
      }
      
      this.setState({ loading: false });
    });
  };

  render() {
    if (this.props.forbidden) {
      return <FormattedMessage {...messages.forbidden} />;
    }
    const {
      isLoading,
      simulated,
      hasError,
      error,
      history,
      intl,
      loader,
      evaluationOnlineDates,
    } = this.props;
    let { showUploadModal, showUploadComposingModal, loading } = this.state;

    const courseOptions = helpers.getCourseOptions(this.props.groups, this.state.idCSchool, true);

    const simulatedDates = simulated && simulated.evaluation && simulated.evaluation.dates;
    const simulatedApplicationMethod =
      simulated && simulated.evaluation && simulated.evaluation.applicationMethod;

    const isContentMapCompleted = !!find(
      simulatedDates,
      (d) => d.component === 'contentmap' && d.complete === true,
    );

    const diagrammingCompleted = this.isDiagrammingCompleted();

    const isCompleted = !!find(simulatedDates, (q) => q.component === 'questions' && q.complete);

    const isEditable = !!find(
      simulatedDates,
      (d) => d.component === 'questions_added' && d.complete === true,
    );

    let isDisabled = !!find(simulatedDates, (q) => q.component === 'questions_added' && q.pending);

    if (!isCompleted && !isEditable) {
      isDisabled = true;
    }

    let cardClassName = 'card-school disabled';
    if (isCompleted) {
      cardClassName = 'card-school completed';
    }
    if (isEditable && !isCompleted) {
      cardClassName = 'card-school';
    }

    return (
      <div>
        <Loader
          show={loader || loading}
          message={this.state.loadingMessage}
          batchMessage={this.state.socketMessage}
        />

        {simulated ? (
          <div id="simulated-edition-container">
            {/* Title and initial icons */}
            <Row className="align-items-end">
              <Col md={6}>
                <Link className="return" to="/simulated">
                  <i className="ti-arrow-left" />
                  {intl.formatMessage(messages.back)}
                </Link>
                <h5 className="title">{intl.formatMessage(messages.title)}</h5>
                <h6 className="subtitle">
                  {simulated.evaluation.levelSegment.map((l) => (
                    <div>{l}</div>
                  ))}
                  <div>{simulated.contract.application}</div>
                </h6>
              </Col>
            </Row>
            {/* School and course filter */}
            <Row className="align-items-center">
              <Col lg={2}>
                <h6 className="id mb-0">
                  <div>
                    {simulated.evaluation.catalogings.map((c) => c.abbreviation).join(' | ')}
                  </div>
                  <div>ID: {simulated.evaluation.idString}</div>
                </h6>
              </Col>
              <Col lg={6}>
                <Select
                  containerClassName="mt-0"
                  options={this.props.schoolOptions}
                  nullable
                  value={this.state.idCSchool}
                  onChange={this.handleChangeSchoolFilter}
                  placeholder={intl.formatMessage(messages.school)}
                />
              </Col>
              <Col lg={4}>
                <Select
                  containerClassName="mt-0"
                  disabled={!this.state.idCSchool}
                  nullable
                  value={this.state.idESCourse}
                  options={courseOptions}
                  onChange={this.handleChangeIdESCourseFilter}
                  placeholder={intl.formatMessage(messages.class)}
                />
              </Col>
            </Row>

            <hr className="my-5" />

            <div className="grid-3 mt-5">
              {simulated.contentmap && Number(simulated.canEditContentMapAbilities) === 1 && (
                <Card
                  className={classNames('card-school', {
                    completed: isContentMapCompleted,
                  })}
                  onClick={() => history.push(`/simulated/${simulated.evaluation.id}/contentmap`)}
                >
                  <div className="card-school-flex">
                    <div style={{ width: '100%' }}>
                      <i className="pt-3 cm-icon pe-7s-light" />
                      <h5 className="card-title my-0" style={{ color: '#F59F8D' }}>
                        {intl.formatMessage(messages.contentMapAndAbilitys)}
                      </h5>
                      {isContentMapCompleted && (
                        <p className="mt-3">
                          {simulated.approvedAbilities}{' '}
                          {intl.formatMessage(messages.abilitiesApproved)}
                        </p>
                      )}
                      {!isContentMapCompleted && (
                        <p className="mt-3">
                          {simulated.contentmapAbilities}{' '}
                          {intl.formatMessage(messages.abilitiesRegistred)}
                          <br />
                          {simulated.abilitiesToApprove}{' '}
                          {intl.formatMessage(messages.abilitiesAvaliable)}
                        </p>
                      )}
                      {/* {simulated.evaluation.contentmapDate && (
                        <p className="card-date">
                          <i className="cm-icon pe-7s-date" /> {intl.formatMessage(messages.to)}{' '}
                          {simulated.evaluation.contentmapDate}
                        </p>
                      )} */}
                    </div>
                    <Button className="btn-sm btn-warning btn-card">
                      {intl.formatMessage(
                        isContentMapCompleted ? messages.completed : messages.edit,
                      )}
                    </Button>
                  </div>
                </Card>
              )}

              {simulated.evaluation.catalogings && Number(simulated.canViewEvaluation) === 1 && (
                <Card
                  className={cardClassName}
                  onClick={() => {
                    if (isDisabled) {
                      return;
                    }
                    history.push(`/simulated/${simulated.evaluation.id}/questions`);
                  }}
                >
                  <div className="card-school-flex">
                    <div style={{ width: '100%' }}>
                      <i className="pt-3 cm-icon pe-7s-help1 " />
                      <h5 className="card-title my-0" style={{ color: '#F59F8D' }}>
                        {intl.formatMessage(messages.questionsTitle)}
                      </h5>
                      {simulated.evaluation.catalogings.map((el, i) => (
                        <p key={el.id} className={`m-0${i === 0 ? ' mt-3' : ''}`}>
                          {el.abbreviation}: {el.quantity} {intl.formatMessage(messages.questions)}
                        </p>
                      ))}
                      {/* {simulated.evaluation.questionsDate && (
                        <p className="mt-3 card-date">
                          <i className="cm-icon pe-7s-date" /> {intl.formatMessage(messages.to)}{' '}
                          {simulated.evaluation.questionsDate}
                        </p>
                      )} */}
                    </div>
                    {/* {isEditable && (
                      <Button
                        className="btn-sm btn-card btn-warning"
                        style={{ marginBottom: '10px' }}
                      >
                        {intl.formatMessage(messages.edit)}
                      </Button>
                    )} */}

                    {isCompleted && (
                      <Button className="btn-sm btn-card btn-success">
                        {intl.formatMessage(messages.finished)}
                      </Button>
                    )}

                    {isDisabled && (
                      <Button className="btn-sm btn-card btn-disabled">
                        {intl.formatMessage(messages.disabled)}
                      </Button>
                    )}
                  </div>
                </Card>
              )}

              {/* Kit simulados */}
              {this.props.permission !== 0 && simulated.evaluation !== undefined && (
                <Card
                  className={classNames('card-school', {
                    disabled: !diagrammingCompleted,
                  })}
                >
                  <div className="card-school-flex">
                    <div style={{ width: '100%' }}>
                      <div style={{ position: 'relative' }}>
                        <i className="pt-3 cm-icon pe-7s-news-paper" />
                        <i className="notification ti-bell" />
                      </div>
                      <h5 className="card-title my-0" style={{ color: '#F59F8D' }}>
                        {intl.formatMessage(messages.kitTitle)}
                      </h5>
                      <div
                        className="checkbox text-left"
                        style={{ maxWidth: '80%', margin: 'auto' }}
                      >
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck1"
                            type="checkbox"
                            disabled={!diagrammingCompleted}
                            checked={this.state.checkbox.simulatedPdf}
                            onChange={(e) => {
                              this.setState({
                                checkbox: {
                                  ...this.state.checkbox,
                                  simulatedPdf: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck1">
                            {intl.formatMessage(messages.simulatedPdf)}
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck2"
                            type="checkbox"
                            disabled={!diagrammingCompleted}
                            checked={this.state.checkbox.answersPdf}
                            onChange={(e) => {
                              this.setState({
                                checkbox: {
                                  ...this.state.checkbox,
                                  answersPdf: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck2">
                            {intl.formatMessage(messages.answersPdf)}
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck3"
                            type="checkbox"
                            disabled={!diagrammingCompleted}
                            checked={this.state.checkbox.answersCardPdf}
                            onChange={(e) => {
                              this.setState({
                                checkbox: {
                                  ...this.state.checkbox,
                                  answersCardPdf: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck3">
                            {intl.formatMessage(messages.answersCardPdf)}
                          </label>
                        </div>
                        {['3', '4'].includes(simulatedApplicationMethod) && (
                          <div>
                            <div className="custom-control custom-checkbox">
                              <input
                                className="custom-control-input"
                                id="customCheck5"
                                type="checkbox"
                                checked={this.state.checkbox.compositionSheets}
                                onChange={(e) => {
                                  this.setState({
                                    checkbox: {
                                      ...this.state.checkbox,
                                      compositionSheets: e.target.checked,
                                    },
                                  });
                                }}
                              />
                              <label className="custom-control-label" htmlFor="customCheck5">
                                {intl.formatMessage(messages.compositionSheets)}
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {diagrammingCompleted ? (
                      <Button
                        className="btn-sm btn-card btn-warning"
                        onClick={this.showModalDownloadPdf}
                      >
                        {intl.formatMessage(messages.download)}
                      </Button>
                    ) : (
                      <Button className="btn-sm btn-card btn-disabled">
                        {intl.formatMessage(messages.disabled)}
                      </Button>
                    )}
                  </div>
                </Card>
              )}

              {this.props.permission !== 0 && simulated.evaluation !== undefined && (
                <Card className={classNames('card-school', { incomplete: !diagrammingCompleted })}>
                  <div className="card-school-flex">
                    <div style={{ width: '100%' }}>
                      <i className="pt-3 cm-icon pe-7s-check " />
                      <FormattedMessage {...messages.sendCardsSubtitle}>
                        {(txt) => <div className="card-title text-danger">{txt}</div>}
                      </FormattedMessage>
                      <FormattedMessage {...messages.uploadCardsInfo}>
                        {(txt) => <p>{txt}</p>}
                      </FormattedMessage>
                    </div>
                    <FormattedMessage
                      {...(diagrammingCompleted ? messages.uploadButton : messages.disabledButton)}
                    >
                      {(txt) => (
                        <button
                          className="btn btn-sm btn-card btn-primary"
                          onClick={this.handleUploadModal}
                          disabled={!diagrammingCompleted}
                        >
                          {txt}
                        </button>
                      )}
                    </FormattedMessage>
                  </div>
                </Card>
              )}

              {this.props.permission !== 0 &&
                simulated.evaluation !== undefined &&
                ['3', '4'].includes(simulatedApplicationMethod) && (
                  <Card
                    className={classNames('card-school', {
                      incomplete: !diagrammingCompleted,
                    })}
                  >
                    <div className="card-school-flex">
                      <div style={{ width: '100%' }}>
                        <i className="pt-3 cm-icon pe-7s-check " />
                        <FormattedMessage {...messages.sendComposingSubtitle}>
                          {(txt) => <div className="card-title text-danger">{txt}</div>}
                        </FormattedMessage>
                        <FormattedMessage {...messages.uploadComposingInfo}>
                          {(txt) => <p>{txt}</p>}
                        </FormattedMessage>
                      </div>
                      <FormattedMessage
                        {...(diagrammingCompleted
                          ? messages.uploadButton
                          : messages.disabledButton)}
                      >
                        {(txt) => (
                          <button
                            className="btn btn-sm btn-card btn-primary"
                            onClick={this.handleUploadComposingModal}
                            disabled={!diagrammingCompleted}
                          >
                            {txt}
                          </button>
                        )}
                      </FormattedMessage>
                    </div>
                  </Card>
                )}

              {this.props.permission !== 0 &&
                simulated.evaluation !== undefined &&
                ['3', '4'].includes(simulatedApplicationMethod) && (
                  <Card className={classNames('card-school')}>
                    <div className="card-school-flex">
                      <div style={{ width: '100%' }}>
                        <i className="pt-3 cm-icon pe-7s-light" />
                        <FormattedMessage {...messages.downloadComposingDOCSubtitle}>
                          {(txt) => <div className="card-title text-danger">{txt}</div>}
                        </FormattedMessage>
                      </div>
                      <div className="checkbox text-left" style={{ columnCount: '2' }}>
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck6"
                            type="checkbox"
                            checked={this.state.composingCheckbox.first_grade}
                            onChange={(e) => {
                              this.setState({
                                composingCheckbox: {
                                  ...this.state.composingCheckbox,
                                  first_grade: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck6">
                            {intl.formatMessage(messages.first_grade)}
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck7"
                            type="checkbox"
                            checked={this.state.composingCheckbox.second_grade}
                            onChange={(e) => {
                              this.setState({
                                composingCheckbox: {
                                  ...this.state.composingCheckbox,
                                  second_grade: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck7">
                            {intl.formatMessage(messages.second_grade)}
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck8"
                            type="checkbox"
                            checked={this.state.composingCheckbox.third_grade}
                            onChange={(e) => {
                              this.setState({
                                composingCheckbox: {
                                  ...this.state.composingCheckbox,
                                  third_grade: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck8">
                            {intl.formatMessage(messages.third_grade)}
                          </label>
                        </div>
                        <div
                          className="custom-control custom-checkbox"
                          style={{ breakBefore: 'column' }}
                        >
                          <input
                            className="custom-control-input"
                            id="customCheck9"
                            type="checkbox"
                            checked={this.state.composingCheckbox.sixth_year}
                            onChange={(e) => {
                              this.setState({
                                composingCheckbox: {
                                  ...this.state.composingCheckbox,
                                  sixth_year: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck9">
                            {intl.formatMessage(messages.sixth_year)}
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck10"
                            type="checkbox"
                            checked={this.state.composingCheckbox.seventh_year}
                            onChange={(e) => {
                              this.setState({
                                composingCheckbox: {
                                  ...this.state.composingCheckbox,
                                  seventh_year: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck10">
                            {intl.formatMessage(messages.seventh_year)}
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck11"
                            type="checkbox"
                            checked={this.state.composingCheckbox.eighth_year}
                            onChange={(e) => {
                              this.setState({
                                composingCheckbox: {
                                  ...this.state.composingCheckbox,
                                  eighth_year: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck11">
                            {intl.formatMessage(messages.eighth_year)}
                          </label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck12"
                            type="checkbox"
                            checked={this.state.composingCheckbox.ninth_year}
                            onChange={(e) => {
                              this.setState({
                                composingCheckbox: {
                                  ...this.state.composingCheckbox,
                                  ninth_year: e.target.checked,
                                },
                              });
                            }}
                          />
                          <label className="custom-control-label" htmlFor="customCheck12">
                            {intl.formatMessage(messages.ninth_year)}
                          </label>
                        </div>
                      </div>
                      <FormattedMessage {...messages.download}>
                        {(txt) => (
                          <button
                            className="btn btn-sm btn-card btn-primary"
                            onClick={this.handleDownloadComposingDoc}
                          >
                            {txt}
                          </button>
                        )}
                      </FormattedMessage>
                    </div>
                  </Card>
                )}

              {this.props.permission !== 0 &&
                simulated.evaluation !== undefined &&
                simulated.evaluation.applicationMethod === '1' && (
                  <Card className={classNames('card-school')}>
                    <div className="card-school-flex">
                      <div style={{ width: '100%' }}>
                        <i className="pt-3 cm-icon pe-7s-mouse" />
                        <FormattedMessage {...messages.followCardTitle}>
                          {(txt) => <div className="card-title text-danger">{txt}</div>}
                        </FormattedMessage>
                        <FormattedMessage {...messages.followCardText}>
                          {(txt) => <p className="mt-3">{txt}</p>}
                        </FormattedMessage>
                      </div>
                      <FormattedMessage {...messages.follow}>
                        {(txt) => (
                          <button
                            className="btn btn-sm btn-card btn-primary"
                            onClick={() =>
                              this.props.history.push(
                                `/simulated/${simulated.evaluation.id}/onlineprogress`,
                              )
                            }
                          >
                            {txt}
                          </button>
                        )}
                      </FormattedMessage>
                    </div>
                  </Card>
                )}

              {evaluationOnlineDates && (
                <Card
                  className={classNames('card-school')}
                  style={{
                    opacity: evaluationOnlineDates.status === 'false' ? 0.7 : 1,
                  }}
                  onClick={() => {
                    if (evaluationOnlineDates.status === 'true') {
                      history.push({
                        pathname: `/online-simulated/${this.props.idEvaluation}`,
                        search: '',
                        state: {
                          languageSelected: '',
                          courseName: '',
                          idEvaluationOnline: '',
                          evalutationStatus: '',
                          timeEnd: '',
                        },
                      });
                    }
                  }}
                >
                  <div className="card-school-flex">
                    <div style={{ width: '100%' }}>
                      <i className="pt-3 cm-icon pe-7s-file" />
                      <h5
                        className="card-title my-0"
                        style={{
                          color: '#F59F8D',
                        }}
                      >
                        {intl.formatMessage(messages.evaluationOnline)}
                      </h5>
                      <p className="mt-3">{intl.formatMessage(messages.scheduledFor)}:</p>

                      <p className="mt-3">
                        {evaluationOnlineDates.dateStart} {intl.formatMessage(messages.until)}{' '}
                        {evaluationOnlineDates.dateEnd}
                      </p>
                    </div>
                    <Button
                      className={`btn btn-sm btn-warning ${
                        evaluationOnlineDates.status === 'false' && 'btn-disabled'
                      } btn-card`}
                    >
                      {intl.formatMessage(
                        evaluationOnlineDates.status === 'true'
                          ? messages.followup
                          : messages.finished,
                      )}
                    </Button>
                  </div>
                </Card>
              )}
            </div>
          </div>
        ) : (
          <div>{hasError && error}</div>
        )}

        <SelectSchoolModal
          isOpen={this.state.selectSchoolModal}
          schoolOptions={this.props.schoolOptions}
          answersCardPdf={this.state.checkbox.answersCardPdf}
          compositionSheets={this.state.checkbox.compositionSheets}
          schoolSelectedCourses={this.state.schoolSelectedCourses}
          checkboxAllGroups={this.state.checkboxAllGroups}
          onChangeCheckboxAllGroups={this.handleChangeCheckboxAllGroups}
          onDownload={this.handleLoaderAnswerSheet}
          onChangeSchool={this.handleChangeSchool}
          checkboxGroups={this.state.checkboxGroups}
          onChangeCheckboxGroups={this.handleChangeCheckboxGroups}
          idCSchool={this.state.idCSchool}
          errorMessageDownload={this.props.errorMessageDownload}
          intl={intl}
          onClose={() => this.setState({ selectSchoolModal: false })}
        />

        <SimulatedCorrectionTermsOfUseModal
          show={showUploadModal}
          onClose={() => {
            this.dismissHandleUploadModal();
          }}
          onContinue={() => {
            this.handleClickUpload();
          }}
        />

        <ComposingCorrectionTermsOfUseModal
          show={showUploadComposingModal}
          onClose={() => {
            this.dismissHandleUploadComposingModal();
          }}
          onContinue={() => {
            this.handleClickUploadComposing();
          }}
        />
      </div>
    );
  }
}

function SelectSchoolModal({
  isOpen,
  idCSchool,
  answersCardPdf,
  compositionSheets,
  schoolOptions,
  schoolSelectedCourses,
  onClose,
  onDownload,
  onChangeSchool,
  checkboxAllGroups,
  onChangeCheckboxAllGroups,
  checkboxGroups,
  onChangeCheckboxGroups,
  intl,
  errorMessageDownload,
}) {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon="pe-7s-check-circle"
      title={intl.formatMessage(messages.selectSchoolTitle)}
      buttons={[
        {
          label: intl.formatMessage(messages.cancel),
          onClick: onClose,
        },
        {
          label: intl.formatMessage(messages.download),
          onClick: onDownload,
          primary: true,
          disabled: !idCSchool,
        },
      ]}
      half
    >
      <p>
        <Select
          containerClassName="mt-0"
          options={schoolOptions}
          nullable
          onChange={onChangeSchool}
          value={idCSchool}
          placeholder={intl.formatMessage(messages.school)}
        />
      </p>

      {schoolSelectedCourses &&
        schoolSelectedCourses.length > 0 &&
        (answersCardPdf || compositionSheets) && (
          <div>
            <h5
              className="modal-subtitle"
              style={{
                textTransform: 'uppercase',
                fontWeight: 'bold',
                fontSize: '16px',
                color: '#ec745d',
              }}
            >
              {intl.formatMessage(messages.selectGroups)}
            </h5>
            <div className="checkbox text-left" style={{ marginBottom: '10px' }}>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  id="allGroups"
                  type="checkbox"
                  checked={checkboxAllGroups}
                  onChange={onChangeCheckboxAllGroups}
                />
                <label className="custom-control-label" htmlFor="allGroups">
                  {intl.formatMessage(messages.all)}
                </label>
              </div>

              {schoolSelectedCourses.map((course) => (
                <div className="custom-control custom-checkbox">
                  <input
                    key={course.idESCourse}
                    className="custom-control-input"
                    id={`schoolSelectedCourses-${course.idESCourse}`}
                    type="checkbox"
                    name="schoolSelectedCourses"
                    value={course.idESCourse}
                    checked={checkboxGroups[course.idESCourse]}
                    onChange={() => onChangeCheckboxGroups(course.idESCourse)}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor={`schoolSelectedCourses-${course.idESCourse}`}
                  >
                    {course.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}

      {errorMessageDownload && (
        <Alert variant="danger">{intl.formatMessage(messages.noFilesToDownload)}</Alert>
      )}
      <div style={{ textAlign: 'left' }}>
        <p>
          <span style={{ color: '#F59F9B' }}>{intl.formatMessage(messages.important)}</span>{' '}
          {intl.formatMessage(messages.readMePrintTitle)}
        </p>
        <p>
          <b>{intl.formatMessage(messages.readMePrintConfig)}</b>
        </p>
        <ul>
          <li>{intl.formatMessage(messages.readMePrintColor)}</li>
          <li>{intl.formatMessage(messages.readMePrintMode)}</li>
          <li>{intl.formatMessage(messages.readMePrintPaper)}</li>
          <li>{intl.formatMessage(messages.readMePrintOnlyFront)}</li>
        </ul>
        <p>
          <strong>{intl.formatMessage(messages.readMeScanConfig)}</strong>
        </p>
        <ul>
          <li>{intl.formatMessage(messages.readMeScanResolution)}</li>
          <li>{intl.formatMessage(messages.readMeScanPosition)}</li>
          <li>{intl.formatMessage(messages.readMeScanType)}</li>
          <li>{intl.formatMessage(messages.readMeScanAlign)}</li>
          <li>{intl.formatMessage(messages.readMeScanOnlyOneResponseCard)}</li>
          <li>{intl.formatMessage(messages.readMeScanNoBlankCards)}</li>
        </ul>
        <p>{intl.formatMessage(messages.readMeScanAttention)}</p>
      </div>
    </Modal>
  );
}

function mapStateToProps({ app, login, simulated, simulatedEdition }, { match }) {
  return {
    ...match.params,
    ...simulatedEdition,
    user: app.user,
    simulated: simulated.evaluation,
    groups: simulated.groups,
    evaluationLevel: simulated.evaluationLevel,
    schoolOptions: simulated.schoolOptions,
    isLoading: simulated.isLoading,
    hasError: simulated.hasError,
    error: simulated.error,
    forbidden: simulated.forbidden,
  };
}

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    promisify(
      {
        getEvaluationOnlineInProgress,
        getEvaluationInformation,
        checkCoordinatorPermission,
        checkCoordinatorPermissionEvaluation,
        getGroups,
        downloadPdf,
        generateEvaluationAnswerSheetsFiles,
        generateEvaluationAnswerSheetsFilesStatus,
        logDownloadEssayGuidelines,
      },
      {
        include: [
          'getEvaluationOnlineInProgress',
          'getEvaluationInformation',
          'checkCoordinatorPermission',
          'checkCoordinatorPermissionEvaluation',
          'getGroups',
          'downloadPdf',
          'generateEvaluationAnswerSheetsFiles',
          'generateEvaluationAnswerSheetsFilesStatus',
          'logDownloadEssayGuidelines',
        ],
      },
    ),
  ),
)(SimulatedEditionContainer);
